import React, { Component } from "react";
import "./UserMenu.css";
class UserMenu extends Component {
  render() {
    return (
      <div className="dropdown-menu user-menu">
        <a className="dropdown-item" href="/wp-admin/profile.php">
          My Account
        </a>
        <a className="dropdown-item" href="/pay-balance-form">
          Make Payment
        </a>
        <a className="dropdown-item" href="/my-account/customer-logout">
          Log Out
        </a>
      </div>
    );
  }
}

export default UserMenu;
